<div
  class="form-group"
  [formGroup]="formGroup!"
>
  <label
    for="{{ config?.name }}"
    class="mb-1 fw-bold"
  >
    {{ config?.label }}

    @if (config ? showAsterisk(config) : false) {
      *
    }
  </label>
  <input
    type="file"
    libdFileInput
    [name]="config?.name ?? ''"
    [formControlName]="config?.name ?? null"
    [id]="config?.name"
  />

  <div
    libFormFieldError
    [fieldConfig]="config!"
    [formComponent]="fc"
  ></div>
</div>
